// extracted by mini-css-extract-plugin
module.exports = {"socialIcon":"EditableSocial_socialIcon__3DvWl","delete":"EditableSocial_delete__-4tP2","active":"EditableSocial_active__3MXQL"};